import { render, staticRenderFns } from "./roomsForCompany.vue?vue&type=template&id=0a68c840&scoped=true"
import script from "./roomsForCompany.vue?vue&type=script&lang=js"
export * from "./roomsForCompany.vue?vue&type=script&lang=js"
import style0 from "./roomsForCompany.vue?vue&type=style&index=0&id=0a68c840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a68c840",
  null
  
)

export default component.exports